import React, { useEffect } from "react";
import ServiceListingSlider from "../component/ServiceListingSlider";
import ClientTestimonialSection from "../component/ClientTestimonialSection";
import { NavLink } from "react-router-dom";
import MissionVisionValueSection from "../component/MissionVisionValueSection";
import AnimatedMissionVisionValueSection from "../component/AnimatedMissionVisionValueSection";
import Expertise from "../component/OurExpertise";
import OtherServices from "../component/OtherServices";

const About = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("show", entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(".fade-in-left, .fade-in-right");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);


  return (
    <>
      {/* Hero Section */}
      <div className="th-hero-wrapper hero-1" id="hero">
        <div className="hero-img tilt-active">
          <img
            src="assets/img/hero/hero_img_1_1.png"
            // src="assets/img/hero/aboutushero3.png"
            loading="lazy"
            alt="Hero Image"
          />
        </div>
        <div className="container">
          <div className="hero-style1">
            {/* <span className="hero-subtitle">About</span> */}
            <h1 className="hero-title">
              Web Development and Digital Center : warrgyizmorsch
            </h1>
            <p className="hero-text">
              We are Warrgyizmorsch: your partner in digital marketing.
              Warrgyizmorsch creates tailor-made web development, e-commerce,
              mobile, marketing, and data solutions that earn revenue for your
              business. Our sole focus is on innovation, quality, and the
              success of our customers, helping them earn revenue in the
              fast-paced digital world.
              <br />
              <br />
              Founded in 2017, Warrgyizmorsch has grown from humble beginnings
              driven by a passion to keep clients first. We helped many flourish
              their business with trust and results.
              <br />
              <br />
              We hope you enjoy our services as much as we enjoy offering them.
              Feel free to contact us with any questions or feedback!
            </p>
            <div className="btn-group">
              <NavLink to="/contact-us" className="th-btn">
                CONTACT US <i className="fa-regular fa-arrow-right ms-2"></i>
              </NavLink>
            </div>
          </div>
        </div>
        <div className="hero-shape1">
          <img
            src="assets/img/hero/hero_shape_1_1.svg"
            loading="lazy"
            alt="shape"
          />
        </div>
        <div className="hero-shape2">
          <img
            src="assets/img/hero/hero_shape_1_2.svg"
            loading="lazy"
            alt="shape"
          />
        </div>
        <div className="hero-shape3">
          <img
            src="assets/img/hero/hero_shape_1_3.svg"
            loading="lazy"
            alt="shape"
          />
        </div>
      </div>

      {/* Mission , Vision and Value  */}
      {/* <MissionVisionValueSection /> */}
      <AnimatedMissionVisionValueSection />

      {/* Our Services  */}
      {/* <ServiceListingSlider /> */}
      <Expertise />

      {/* Other service  */}
      <OtherServices />

      {/* Client Testimonials  */}
      <ClientTestimonialSection />
    </>
  );
};

export default About;